// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AyF-O","col":"styles_col__36P8N"};